import { useAppDispatch, useAppSelector } from '../../../../hooks/useRedux';

import { useFormik } from 'formik';

import organizationSlice from '../../store/slice/organization.slice';

import Input from '../../../../components/Input';
import Button from '../../../../components/Button';

import { LoanOfficerSubscriptionSchema } from '../../../../lib/validation';

import { InputTypes } from '../../../../enums/enums';

import { RootState } from '../../../../store';
import { InviteOrganizationBodyTypes } from '../../store/types/organization.types';

import { SPECIAL_KEYS } from '../../../../lib/constants';

const SubscriptionForLoanOfficer = ({
  handleCloseModal,
}: {
  handleCloseModal: () => void;
}): JSX.Element => {
  const initialValues = {
    plan_name: '',
    price_per_month: '',
  };

  const dispatch = useAppDispatch();

  const { addOrganizationBody, isInviteOrganizationLoading } = useAppSelector(
    (state: RootState) => state.organizations
  );

  const onSubmit = (): void => {
    const { organization_id, organization_payment_type_details } =
      addOrganizationBody;
    if (organization_id && organization_payment_type_details) {
      const body: InviteOrganizationBodyTypes = {
        organization_id,
        organization_payment_type_id: organization_payment_type_details?.id,
        user_subscriptions: [
          {
            plan: values.plan_name,
            price: values.price_per_month,
          },
        ],
      };
      dispatch(organizationSlice.actions.inviteOrganization(body));
    }
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues,
      validationSchema: LoanOfficerSubscriptionSchema,
      onSubmit,
    });

  return (
    <>
      <div className="h-[200px] overflow-y-auto mt-4">
        <h3 className="text-inter-black text-sm pb-1 h-6 flex items-end font-semibold">
          Loan Officer
        </h3>
        <div
          className={`flex w-full flex-col pb-1 border-side-nav-button-bg mb-2`}
        >
          <div className="flex w-full">
            <div className="w-1/2 mr-2 flex flex-col">
              <label
                className="text-inter-black text-xs pb-1 h-6 flex items-end font-medium"
                htmlFor="User Limit"
              >
                Plan Name
              </label>

              <Input
                placeholder="Plan Name"
                label="Plan Name"
                name="plan_name"
                id="plan_name"
                colorLabel="text-inter-black"
                type={InputTypes.TEXT}
                labelHide={false}
                inputIcon={false}
                autoFocus={true}
                value={values.plan_name}
                errors={Boolean(touched.plan_name && errors.plan_name)}
                helperText={touched.plan_name && errors.plan_name}
                onChange={handleChange}
                onBlur={handleBlur}
                style={{
                  borderColor: `${
                    touched.plan_name && errors.plan_name ? '#FF3E1D' : ''
                  }`,
                }}
              />
            </div>
            <div className="w-1/2 flex items-end">
              <div className="w-full mx-2 flex flex-col">
                <label
                  className={`text-inter-black text-xs pb-1 h-6 flex items-end font-medium`}
                  htmlFor="Price/Month"
                >
                  Price/Month
                </label>

                <Input
                  placeholder="Amount"
                  label="Price/Month"
                  name="price_per_month"
                  id="price_per_month"
                  colorLabel="text-inter-black font-medium"
                  inputIcon={false}
                  labelHide={false}
                  type={InputTypes.TEXT}
                  value={values.price_per_month}
                  errors={Boolean(
                    touched.price_per_month && errors.price_per_month
                  )}
                  helperText={touched.price_per_month && errors.price_per_month}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  onKeyDown={e => {
                    if (
                      !SPECIAL_KEYS.includes(e.key) &&
                      !e.metaKey &&
                      /\D/.test(e.key)
                    ) {
                      e.preventDefault();
                    }
                  }}
                  style={{
                    borderColor: `${
                      errors.price_per_month && touched.price_per_month
                        ? '#FF3E1D'
                        : ''
                    }`,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="pt-5 pb-2 flex w-full relative">
        <Button
          text="Cancel"
          type="button"
          onClick={handleCloseModal}
          className="inline-flex w-1/2 mr-2 h-46 border border-grey-light-color hover:border-red-error-color hover:text-red-error-color 
          justify-center items-center text-inter-black text-sm rounded"
        />

        <Button
          text="Send Invite"
          type="button"
          disabled={isInviteOrganizationLoading}
          isLoading={isInviteOrganizationLoading}
          className={`inline-flex w-1/2 ml-2 h-46 border border-button-light-green ${
            !isInviteOrganizationLoading &&
            'hover:bg-white hover:text-button-light-green'
          }   bg-button-light-green justify-center items-center text-white text-sm rounded `}
          onClick={e => {
            e.preventDefault();
            handleSubmit();
          }}
        />
      </div>
    </>
  );
};

export default SubscriptionForLoanOfficer;
